import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { useNavigate, useSearchParams } from "react-router-dom";

import MgDialog from "../Dialog";
import SMSInputBox from "../input/SMSInputBox";
import { useLoginViaSmsVerificationCode } from "../../api/smsVerification/smsVerificationApi";
import { useSmsVerificationInfoStore } from "../../store/smsVerificationStore";
import { transferToNative, WebAppBridge } from "../../lib/WebAppBridge";
import { useDeviceInfoStore } from "../../store/deviceInfoStore";
import { useLoginWithEmail } from "@src/api/emailVerification/emailVerificationApi";
import { useSignupExpertStore } from "@src/store/signupExpertStore";

const NONE_EXIST_USER_ERROR_CODE = 401;

const LoginOrSignupViaSMS = () => {
    const [errorMessage, setErrorMessage] = useState("");
    const [isOpenErrorDialog, setIsOpenErrorDialog] = useState(false);
    const { smsVerificationInfo, setSmsVerificationInfo, setPartnerCode } = useSmsVerificationInfoStore();
    const { setPartialState, form } = useSignupExpertStore();
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    var Agent = navigator.userAgent.toLowerCase();
    let loginType = "";

    if (Agent.indexOf("android") > -1) {
        // 안드로이드
        loginType = "android";
    } else if (Agent.indexOf("iphone") > -1) {
        // IOS
        loginType = "ios";
    }

    const { mutate: loginViaSmsCode } = useLoginViaSmsVerificationCode();
    const { deviceInfo, setDeviceInfo } = useDeviceInfoStore();

    WebAppBridge.onGetDeviceInfo = async (deviceId: string, pushToken: string) => {
        setDeviceInfo({ deviceId, pushToken });
    };

    // Login Success Method
    const handleLoginSuccess = (data: any) => {
        // 네이티브 브릿지 호출
        if (data.accessToken && data.refreshToken) {
            localStorage.setItem("accessToken", data.accessToken);
            localStorage.setItem("refreshToken", data.refreshToken);
            transferToNative(
                JSON.stringify({
                    accessToken: data.accessToken,
                    refreshToken: data.refreshToken,
                }),
                "onRedirectHomeWithToken",
            );
            console.log("Bridge Request Success");
        }
    };

    // Login Error Method
    const handleLoginError = (error: any) => {
        const statusCode = error?.response?.data?.statusCode;
        if (statusCode === NONE_EXIST_USER_ERROR_CODE) {
            setPartialState({
                form: {
                    ...form,
                    phone: smsVerificationInfo.phone,
                    deviceId: deviceInfo.deviceId,
                    pushToken: deviceInfo.pushToken,
                    osType: loginType,
                },
            });
            navigate("/usertype");
        } else {
            setErrorMessage(error?.response?.data?.message || "알 수 없는 오류입니다.");
            setIsOpenErrorDialog(true);
        }
    };

    // SMS Login
    const handleMatchSuccess = () => {
        loginViaSmsCode(
            {
                phone: smsVerificationInfo.phone,
                loginType,
                deviceId: deviceInfo.deviceId,
                pushToken: deviceInfo.pushToken,
            },
            {
                onSuccess: handleLoginSuccess,
                onError: handleLoginError,
            },
        );
    };

    // Mail Login
    const { mutate: loginWithEmail } = useLoginWithEmail();

    const handleMatchSuccessWithEmail = () => {
        let email = "";
        let password = "";

        if (smsVerificationInfo.phone.startsWith("@")) {
            const withoutAt = smsVerificationInfo.phone.slice(1);
            [email, password] = withoutAt.split("/");
        } else if (smsVerificationInfo.phone.startsWith("t")) {
            const [rawEmail, pw] = smsVerificationInfo.phone.split("/");
            email = `${rawEmail}@msga.msg`;
            password = pw;
        } else {
            return;
        }

        loginWithEmail(
            {
                id: email,
                password: { password: password },
                osType: loginType,
                pushToken: deviceInfo.pushToken,
                deviceId: deviceInfo.deviceId,
            },
            {
                onSuccess: handleLoginSuccess,
                onError: handleLoginError,
            },
        );
    };

    useEffect(() => {
        setSmsVerificationInfo({ phone: "", code: "" });
    }, []);

    useEffect(() => {
        const partnerCode = searchParams.get("partnerCode");
        if (!partnerCode) return;
        setPartnerCode(partnerCode);
    }, [searchParams, setPartnerCode]);

    return (
        <ContainerStyle>
            <SMSInputBox
                onMatchSuccess={handleMatchSuccess}
                onLoginWithEmail={handleMatchSuccessWithEmail}
                submitButtonText="로그인 (회원가입)"
            />
            {errorMessage && (
                <MgDialog contents={errorMessage} onCloseView={() => setIsOpenErrorDialog(false)} open={isOpenErrorDialog} />
            )}
        </ContainerStyle>
    );
};

export default LoginOrSignupViaSMS;

const ContainerStyle = styled.div`
    position: relative;
    padding-bottom: 34px;

    @media (max-width: 768px) {
        padding-bottom: 0px;
    }
`;
